import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'insert-edit-number',
  templateUrl: './number.component.html',
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective }
  ]
})
export class NumberComponent {
  @Input() fieldName!: string;
  @Input() label!: string;
  @Input() digits: number = 0;
  @Input() prefix: string | undefined = undefined;
  @Input() suffix: string | undefined = undefined;
  @Input() required: boolean = false;

  constructor(private formGroupDirective: FormGroupDirective) {}

  getFormControlField() {
    return this.formGroupDirective.form.get(this.fieldName);
  }

  getError(): string | undefined {
    if(!!this.getFormControlField()?.errors) {
      return Object.keys(this.getFormControlField()?.errors as ValidationErrors)[0];
    }
    
    return undefined;
  }
}
